/**
 * Some elements (like the bootstrap homepage carousel) don't
 * work very will with visibility observer polyfill.
 *
 * VisibilityChangeAnnouncer listens for specific registered events, and aggregates
 * them into a single event.
 *
 * For convenience, it can also be used to easily register handlers against that
 * single event.
 */
export default class VisibilityChangeAnnouncer {
    /**
     * Registers an event to be aggregated.
     * @param {String} eventToRegister An event for which to listen.
     */
    static registerEvent(eventToRegister) {
        $(document).on(eventToRegister, VisibilityChangeAnnouncer._triggerFunc);
    }

    /**
     * Registers a handler to be executed when the
     * aggregate event is triggered.
     * @param {function()} handlerFunc The function to be triggered.
     */
    static registerHandler(handlerFunc) {
        $(document).on(VisibilityChangeAnnouncer.AGGREGATE_EVENT, handlerFunc);
    }

    static _triggerFunc() {
        $(document).trigger(VisibilityChangeAnnouncer.AGGREGATE_EVENT);
    };
}
/**
 * The aggregate event triggered by each registered event.
 * @type {string}
 */
VisibilityChangeAnnouncer.AGGREGATE_EVENT = "eventforwardingservice.visibility.change"



// WEBPACK FOOTER //
// ./resources/assets/js/visibility-change-announcer.js